var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gender"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 3V7C18 7.28333 17.9042 7.52083 17.7125 7.7125C17.5208 7.90417 17.2833 8 17 8C16.7167 8 16.4792 7.90417 16.2875 7.7125C16.0958 7.52083 16 7.28333 16 7V5.425L12.025 9.375C12.3417 9.84167 12.5833 10.3375 12.75 10.8625C12.9167 11.3875 13 11.9333 13 12.5C13 14.0333 12.4667 15.3333 11.4 16.4C10.3333 17.4667 9.03333 18 7.5 18C5.96667 18 4.66667 17.4667 3.6 16.4C2.53333 15.3333 2 14.0333 2 12.5C2 10.9667 2.53333 9.66667 3.6 8.6C4.66667 7.53333 5.96667 7 7.5 7C8.05 7 8.59167 7.07917 9.125 7.2375C9.65833 7.39583 10.15 7.64167 10.6 7.975L14.575 4H13C12.7167 4 12.4792 3.90417 12.2875 3.7125C12.0958 3.52083 12 3.28333 12 3C12 2.71667 12.0958 2.47917 12.2875 2.2875C12.4792 2.09583 12.7167 2 13 2H17C17.2833 2 17.5208 2.09583 17.7125 2.2875C17.9042 2.47917 18 2.71667 18 3ZM7.5 9C6.53333 9 5.70833 9.34167 5.025 10.025C4.34167 10.7083 4 11.5333 4 12.5C4 13.4667 4.34167 14.2917 5.025 14.975C5.70833 15.6583 6.53333 16 7.5 16C8.46667 16 9.29167 15.6583 9.975 14.975C10.6583 14.2917 11 13.4667 11 12.5C11 11.5333 10.6583 10.7083 9.975 10.025C9.29167 9.34167 8.46667 9 7.5 9Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/male-icon.68865be0143197c9994dcc84c94bf1dd.svg";
export { ForwardRef as ReactComponent };